import React from 'react';
import styled from 'styled-components';
import { RouteLink } from '~/components';
import { useWorkspace } from '~/contexts';
import { buildSections } from './useMemberAssociations';
import { uniqueId } from 'lodash';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Associations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

const ListItem = styled.li`
  list-style: initial;
  list-style-position: inside;
  padding-left: 0.6rem;
`;

const Separator = styled.span`
  padding: 0rem 0.3rem;
`;

/** Renders the grouped, linked list of a member's associations. */
export default function MemberAssociationsList({ data }) {
  const { workspace } = useWorkspace();

  const renderItem = ({ type, project, client, ...dataItem }) => {
    switch (type) {
      case 'projectAdmin':
        return (
          <>
            <RouteLink
              to={`/app/${workspace.key}/portfolio/projects/${project.client.key}/${project.key}`}
              target="_blank">
              {project.name}
            </RouteLink>
            <Separator>/</Separator>
            <RouteLink to={`/app/${workspace.key}/portfolio/clients/${project.client.key}`} target="_blank">
              {project.client.name}
            </RouteLink>
          </>
        );
      case 'projectSalesRepresentative':
      case 'timeApproval':
      case 'expenseApproval':
        return (
          <>
            <RouteLink to={`/app/${workspace.key}/portfolio/projects/${client.key}/${dataItem?.key}`} target="_blank">
              {dataItem.name}
            </RouteLink>
            <Separator>/</Separator>
            <RouteLink to={`/app/${workspace.key}/portfolio/clients/${client.key}`} target="_blank">
              {client.name}
            </RouteLink>
          </>
        );
      case 'client':
        return (
          <RouteLink to={`/app/${workspace.key}/portfolio/clients/${dataItem.key}`} target="_blank">
            {dataItem.name}
          </RouteLink>
        );
      case 'member':
        return (
          <RouteLink to={`/app/${workspace.key}/settings/members/details/${dataItem.id}`} target="_blank">
            {dataItem.name}
          </RouteLink>
        );
    }
  };

  return (
    <Body>
      {buildSections(data).map((item) =>
        item?.data?.length ? (
          <Associations key={item.title}>
            {item.title}:
            <ul>
              {item.data.map((entry) => (
                <ListItem key={uniqueId()}>{renderItem(entry)}</ListItem>
              ))}
            </ul>
          </Associations>
        ) : null,
      )}
    </Body>
  );
}
